var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgTrophyIneligible = function SvgTrophyIneligible(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    fill: "none",
    viewBox: "0 0 16 16"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeWidth: 1.5,
    d: "m3.237 12 10-11"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M11.21 1H4.207a.6.6 0 0 0-.6.6v1.296h-1.77a.6.6 0 0 0-.6.6V4.92a2.971 2.971 0 0 0 2.404 2.916c.05.404.155.79.307 1.153l.93-1.024a3.205 3.205 0 0 1-.07-.675V2.2h5.311l1.09-1.2Zm-4.368 9.265a3.193 3.193 0 0 0 4.35-2.976v-1.81l1.2-1.32v2.426a1.771 1.771 0 0 0 1.171-1.666v-.823h-1.114l1.091-1.2h.623a.6.6 0 0 1 .6.6V4.92a2.971 2.971 0 0 1-2.404 2.916A4.395 4.395 0 0 1 8.6 11.64V13.8h1.77a.6.6 0 1 1 0 1.2H5.63a.6.6 0 1 1 0-1.2H7.4v-2.16a4.361 4.361 0 0 1-1.406-.442l.848-.933ZM2.437 4.096h1.17v2.489a1.771 1.771 0 0 1-1.17-1.666v-.823Z",
    clipRule: "evenodd"
  })));
};
export default SvgTrophyIneligible;